
import React from 'react';
import { Molecule } from 'AppReact';
import styled from 'styled-components';
import { Text, Total } from './atoms';


const template = styled.div`
  display: flex;
`;


export default Molecule({
  template: template,
  atoms: [
    {
      component: Text,
      name: 'Time',
      displayValue: ({ time }) => time ?? "",
    },
    {
      component: Total,
      name: 'Total',
      displayValue: ({ total }) => ` Total: ${ total ?? "" }` ,
    },

  ]
})